export class CmsDevicePreviewToggle {
    constructor(private readonly root: HTMLElement) {}

    init(): void {
        this.root.querySelectorAll<HTMLButtonElement>("[data-cms-device]").forEach((button) => {
            button.addEventListener("click", () => {
                const device = button.dataset.cmsDevice ?? "desktop";
                this.root.dataset.cmsDeviceMode = device;
                this.root.querySelectorAll<HTMLButtonElement>("[data-cms-device]").forEach((item) => {
                    const active = item === button;
                    item.classList.toggle("is-active", active);
                    item.setAttribute("aria-pressed", String(active));
                });
            });
        });
    }
}
